import React from 'react';
import LocationTemplate from './LocationTemplate';

const VanceboroPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Vanceboro"
      stateName="North Carolina"
      countyName="Craven"
      zipCodes={["28586"]}
      latitude={35.3074}
      longitude={-77.1544}
      population={994}
      historicalFact="Named after Zebulon Vance, Civil War governor of North Carolina."
      nearbyTowns={[
        "New Bern, NC",
        "Washington, NC",
        "Cove City, NC",
        "Dover, NC",
        "Oriental, NC",
        "Chocowinity, NC",
        "Arapahoe, NC",
        "Bath, NC"
      ]}
    />
  );
};

export default VanceboroPage;